import {
  DetailedDataReportFilters,
  ReportFiltersTypeName,
  SortOptions,
  StandardDeliveryDeviceHigherCategoryReportFilters,
  StandardDeliveryDeviceHigherCategoryReportFiltersInput,
  StandardDeliveryReportFilters,
  StandardDeliveryReportFiltersInput,
  TemplatesWithReportsQuery,
} from '../types';

export const isStandardDeliveryDeviceHigherCategoryReportFilters = (
  filters: TemplateReport['filters']
): filters is StandardDeliveryDeviceHigherCategoryReportFilters => {
  return filters.__typename === ReportFiltersTypeName.StandardDeliveryDeviceHigherCategoryReportFilters;
};

export const isStandardDeliveryReportFilters = (
  filters: TemplateReport['filters']
): filters is StandardDeliveryReportFilters => {
  return filters.__typename === ReportFiltersTypeName.StandardDeliveryReportFilters;
};

export type Template = TemplatesWithReportsQuery['templatesWithReports'][0];

export type TemplateReport = Template['reports'][0];

type DetailedDataReportExportFilters = DetailedDataReportFilters;

export type StandardDeliveryDeviceHigherCategoryExportReport =
  StandardDeliveryDeviceHigherCategoryReportFiltersInput & {
    __typename?: StandardDeliveryDeviceHigherCategoryReportFilters['__typename'];
  };

export type StandardDeliveryReportExportFilters = StandardDeliveryReportFiltersInput & {
  __typename?: StandardDeliveryReportFilters['__typename'];
};

type ExportReportFilters =
  | DetailedDataReportExportFilters
  | StandardDeliveryDeviceHigherCategoryExportReport
  | StandardDeliveryReportExportFilters;

export type ReportForExport = Pick<
  TemplateReport,
  'templateId' | 'dateRange' | 'endDate' | 'startDate' | 'exportFormat'
> & {
  filters: ExportReportFilters;
  name?: TemplateReport['name'];
};

export type ExportReportOptions = SortOptions & {
  searchTerm?: string;
};

export const isStandardDeliveryDeviceHigherCategoryReportExportFilters = (
  filters: ExportReportFilters
): filters is StandardDeliveryDeviceHigherCategoryExportReport => {
  return filters.__typename === ReportFiltersTypeName.StandardDeliveryDeviceHigherCategoryReportFilters;
};

export const isStandardDeliveryReportExportFilters = (
  filters: ExportReportFilters
): filters is StandardDeliveryReportExportFilters => {
  return filters.__typename === ReportFiltersTypeName.StandardDeliveryReportFilters;
};

export const isDetailedDataReportExportFilters = (filters: ExportReportFilters): filters is DetailedDataReportFilters =>
  filters.__typename === ReportFiltersTypeName.DetailedDataReportFilters;
